export const getByTestId = (container: HTMLDivElement, testId: string) =>
  container.querySelector(`[data-test-id=${testId}]`);
